import React from 'react';
import { useLiveFeed } from './live/LiveFeedProvider';
import TickerNumber from './live/TickerNumber';

const Segment = ({ label, children, color = '#E5E5E5' }) => (
  <span style={{
    display: 'inline-flex', alignItems: 'center', gap: 8,
    padding: '0 20px', whiteSpace: 'nowrap',
    fontFamily: "'Space Mono',monospace", fontSize: 10,
    color, textTransform: 'uppercase', letterSpacing: '0.2em',
  }}>
    <span style={{ color: '#525252' }}>{label}</span>
    {children}
    <span style={{ color: '#1A1A1A' }}>·</span>
  </span>
);

const LiveTickerStrip = () => {
  const feed = useLiveFeed();
  const {
    revenueToday, jobsDoneToday, skuStockLow, techniciansOnShift,
    callbacksToday, safetyDaysWithoutIncident, insuranceSplitPct,
    avgTicketR, wipAgeP90Mins,
  } = feed;
  const p90 = wipAgeP90Mins[wipAgeP90Mins.length - 1] ?? 0;

  const row = (
    <>
      <Segment label="Rev_Today"><span>R </span><TickerNumber value={revenueToday} digits={6} /></Segment>
      <Segment label="Jobs_Done"><TickerNumber value={jobsDoneToday} digits={3} /></Segment>
      <Segment label="SKU_Low" color="#FFB800"><TickerNumber value={skuStockLow} digits={2} /></Segment>
      <Segment label="Techs"><TickerNumber value={techniciansOnShift} digits={2} /></Segment>
      <Segment label="Callbacks" color="#FFB800"><TickerNumber value={callbacksToday} digits={2} /></Segment>
      <Segment label="Safety" color="#00FF41"><TickerNumber value={safetyDaysWithoutIncident} digits={3} />_days</Segment>
      <Segment label="Ins_Split"><TickerNumber value={insuranceSplitPct} digits={2} />/{100 - insuranceSplitPct}</Segment>
      <Segment label="Avg_Ticket"><span>R </span><TickerNumber value={avgTicketR} digits={4} /></Segment>
      <Segment label="P90_Wip"><TickerNumber value={p90} digits={2} />m</Segment>
    </>
  );

  return (
    <>
      <style>{`
        @keyframes pg-ticker-scroll {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        .pg-ticker-track {
          display: inline-block;
          animation: pg-ticker-scroll 60s linear infinite;
          will-change: transform;
        }
        .pg-ticker-strip:hover .pg-ticker-track { animation-play-state: paused; }
        @media (prefers-reduced-motion: reduce) {
          .pg-ticker-track { animation: none !important; }
        }
      `}</style>
      <div
        className="pg-ticker-strip"
        style={{
          height: 32,
          borderTop: '1px solid rgba(255,255,255,0.1)',
          borderBottom: '1px solid rgba(255,255,255,0.1)',
          background: 'rgba(255,255,255,0.02)',
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
        }}
      >
        <div className="pg-ticker-track">
          {row}
          {row}
        </div>
      </div>
    </>
  );
};

export default LiveTickerStrip;
